<template>
<div>
    <v-dialog v-if="aktifmi" persistent max-width="700px" v-model="dialog"  @keydown.esc="cancel">
        <v-card>
            <v-card-title style="background-color:#01579B">
                <span class="headline white--text">{{$t('Company-Seller-Common-Information')}}</span>
            </v-card-title>
            <v-card-text class="pa-4">
                <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                        <v-form ref="saticiortakbilgi">
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md6>
                                        <genelarama apiname="SaticiAra" :tip="12" v-model="value.turOperatoru" :label="$t('Tour-Operator')"></genelarama>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6>
                                        <genelarama apiname="MasrafMerkeziAra" v-model="value.masrafMerkezi" :label="$t('Expense-Center-v2')"></genelarama>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md6>
                                        <cariaracomp v-bind:etiket="$t('Cost-Current')" v-model="value.maliyetCariKod.kod" ></cariaracomp>
                                    </v-flex>
                                    <v-flex xs12 sm12 md6>
                                        <geneltipara tip="AcenteDepartman" v-model="value.departman"></geneltipara>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 pa-1 md12>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-autocomplete hide-details :label="$t('Calculate-Commission-Percentage')" item-text="t" item-value="v" v-model="value.komisyonYuzdeTip" :items="[{t: $t('Calculate-From-Sales-Price'), v:0},{t: $t('Calculate-From-Purchasing-Price'), v:1}]">
                                        </v-autocomplete> 
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <parainput :simge="getparabirimi()" v-model="value.komisyonTutar" :etiket="$t('Commission-Amount-v2')" :autocomplete="'autocomplete'"></parainput>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <kur v-model="value.komisyonPara" :kurtarihi="kayitTarihi" ></kur>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <yuzdeinput :etiket="$t('Commission-VAT')" v-model="value.komisyon.KDVOran"  :autocomplete="'autocomplete'">
                                        </yuzdeinput>
                                    </v-flex>

                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                                <geneltipara tip="CariKdvKod" v-bind:aktifmi="faturalimi" v-model="value.kdvID" hide-details :label="$t('VAT-Code')" >
                                </geneltipara>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                                <geneltipara tip="CariKdvIstisnaKod" v-bind:aktifmi="faturalimi" v-model="value.kdvMuafiyetID" hide-details :label="$t('VAT-Exception-Code')" >
                                </geneltipara>
                            </v-flex>
                        </v-form>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-card-actions class="pt-0">
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" text @click.native="agree">{{ $t('save_button') }}</v-btn>
                <v-btn color="grey" text @click.native="cancel">{{$t("cancel_button")}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>

<script>
import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
import genelarama from "@/components/app/coper/comp/genelarama.vue"
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import yuzdeinput from '@/components/app/customcomp/yuzdeinput'
import parainput from '@/components/app/customcomp/parainput'
import helpers from "@/components/app/customcomp/helpers.js"
import kur from "@/components/app/coper/comp/kur.vue";

export default {
    props:{
        value:{
            type:Object
        },
        kayitTarihi:{
            type:String
        },
        aktifmi:{
            type:Boolean,
            default:false
        },
        faturalimi:{
            type:Boolean,
            default:false
        }
    },
     data() {
        return {
        dialog: false,
        cancelValue: {},
        }
    },
    components: {
        cariaracomp,
        genelarama,
        geneltipara,
        yuzdeinput,
        parainput,
        kur
    },
    beforeMount:beforeMount,
    methods: {
        getparabirimi() {
            return helpers.getparabirimiDefault()
        },
        open(value) {
            this.cancelValue = JSON.parse(JSON.stringify(value))
            this.dialog = true
        },
        agree() {
            this.dialog = false
        },
        cancel() {
             this.$emit('dialogIptal',this.cancelValue)
            this.dialog = false

        }
    }
}

function beforeMount(){
    //this.cancelValue = JSON.parse(JSON.stringify(this.value))
}

</script>
